/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Issue_Type_LabelInputs */



/**
* | output |
* | --- |
* | "Issue type" |
*
* @param {Manual_Qc_Issue_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_issue_type_label = /** @type {((inputs?: Manual_Qc_Issue_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Issue_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type d'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabetyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип проблемы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題の種類")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विषय वर्ग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de problema")
	return /** @type {LocalizedString} */ ("Issue type")
});